<template>
	<component
		:is="component"
		v-for="(component, name) in modalWrappers"
		:key="name"
	/>
</template>

<script>
export default {
	name: 'RootModals',
}
</script>

<script setup>
import { defineAsyncComponent } from 'vue'
import { EMITTER_EVENTS } from '@/constants/emitter-events'
import { modalWindowHoc } from '@/composables/modal-window-hoc'

const CreatePlayer = defineAsyncComponent(() =>
	import('@/components/modals/CreatePlayer')
)
const CreateStaff = defineAsyncComponent(() =>
	import('@/components/modals/CreateStaff')
)
const CreateTag = defineAsyncComponent(() =>
	import('@/components/modals/CreateTag')
)
const CreateReferralCode = defineAsyncComponent(() =>
	import('@/components/modals/CreateReferralCode')
)
const CreatePartnersProgram = defineAsyncComponent(() =>
	import('@/components/modals/CreatePartnersProgram')
)
const CreatePartnersTemplate = defineAsyncComponent(() =>
	import('@/components/modals/CreatePartnersTemplate')
)
const AddingCurrency = defineAsyncComponent(() =>
	import('@/components/modals/AddingCurrency')
)
const CreateIntegration = defineAsyncComponent(() =>
	import('@/components/modals/CreateIntegration')
)
const CreateMission = defineAsyncComponent(() =>
	import('@/components/modals/CreateMission')
)
const CreateMissionLevel = defineAsyncComponent(() =>
	import('@/components/modals/CreateMissionLevel')
)
const CreateLevelGoal = defineAsyncComponent(() =>
	import('@/components/modals/CreateLevelGoal')
)
const CreateGoalConfigs = defineAsyncComponent(() =>
	import('@/components/modals/CreateGoalConfigs')
)
const CreateLevelReward = defineAsyncComponent(() =>
	import('@/components/modals/CreateLevelReward')
)
const CreateMaintenance = defineAsyncComponent(() =>
	import('@/components/modals/CreateMaintenance')
)
const CreateText = defineAsyncComponent(() =>
	import('@/components/modals/CreateText')
)
const CreateHall = defineAsyncComponent(() =>
	import('@/components/modals/CreateHall')
)
const EditText = defineAsyncComponent(() =>
	import('@/components/modals/EditText')
)
const ImagePreviewModal = defineAsyncComponent(() =>
	import('@/components/modals/ImagePreviewModal')
)
const CropImageModal = defineAsyncComponent(() =>
	import('@/components/modals/CropImageModal')
)
const DeleteModal = defineAsyncComponent(() =>
	import('@/components/modals/DeleteModal')
)
const PinCode = defineAsyncComponent(() =>
	import('@/components/modals/PinCode')
)
const CreateLanguage = defineAsyncComponent(() =>
	import('@/components/modals/CreateLanguage')
)
const HallStatistics = defineAsyncComponent(() =>
	import('@/components/modals/HallStatistics')
)
const AddingPaymentSystem = defineAsyncComponent(() =>
	import('@/components/modals/AddingPaymentSystem')
)
const AddingCurrencyInCatalog = defineAsyncComponent(() =>
	import('@/components/modals/AddingCurrencyInCatalog')
)
const CreatePaymentMethod = defineAsyncComponent(() =>
	import('@/components/modals/CreatePaymentMethod')
)
const AddingWidget = defineAsyncComponent(() =>
	import('@/components/modals/AddingWidget')
)
const CreatePromoCodes = defineAsyncComponent(() =>
	import('@/components/modals/CreatePromoCodes')
)
const CreateReport = defineAsyncComponent(() =>
	import('@/components/modals/CreateReportModal')
)

const modalWrappers = {
	CreatePaymentMethod: modalWindowHoc(
		CreatePaymentMethod,
		EMITTER_EVENTS.createPaymentMethod
	),
	CreatePlayer: modalWindowHoc(CreatePlayer, EMITTER_EVENTS.createPlayer),
	CreateStaff: modalWindowHoc(CreateStaff, EMITTER_EVENTS.createStaff),
	CreateTag: modalWindowHoc(CreateTag, EMITTER_EVENTS.createTag),
	CreateReferralCode: modalWindowHoc(
		CreateReferralCode,
		EMITTER_EVENTS.createReferralCode
	),
	CreatePartnersProgram: modalWindowHoc(
		CreatePartnersProgram,
		EMITTER_EVENTS.createPartnersProgram
	),
	CreatePartnersTemplate: modalWindowHoc(
		CreatePartnersTemplate,
		EMITTER_EVENTS.createPartnersTemplate
	),
	AddingCurrency: modalWindowHoc(AddingCurrency, EMITTER_EVENTS.addingCurrency),
	CreateIntegration: modalWindowHoc(
		CreateIntegration,
		EMITTER_EVENTS.createIntegration
	),
	CreateMission: modalWindowHoc(CreateMission, EMITTER_EVENTS.createMission),
	CreateMissionLevel: modalWindowHoc(
		CreateMissionLevel,
		EMITTER_EVENTS.createMissionLevel
	),
	CreateLevelGoal: modalWindowHoc(
		CreateLevelGoal,
		EMITTER_EVENTS.createLevelGoal
	),
	CreateGoalConfigs: modalWindowHoc(
		CreateGoalConfigs,
		EMITTER_EVENTS.createGoalConfigs
	),
	CreateLevelReward: modalWindowHoc(
		CreateLevelReward,
		EMITTER_EVENTS.createLevelReward
	),
	CreateMaintenance: modalWindowHoc(
		CreateMaintenance,
		EMITTER_EVENTS.createMaintenance
	),
	CreateText: modalWindowHoc(CreateText, EMITTER_EVENTS.createText),
	CreateHall: modalWindowHoc(CreateHall, EMITTER_EVENTS.createHall),
	EditText: modalWindowHoc(EditText, EMITTER_EVENTS.editText),
	ImagePreviewModal: modalWindowHoc(
		ImagePreviewModal,
		EMITTER_EVENTS.imagePreview
	),
	CropImageModal: modalWindowHoc(CropImageModal, EMITTER_EVENTS.cropImage),
	DeleteModal: modalWindowHoc(DeleteModal, EMITTER_EVENTS.delete),
	PinCode: modalWindowHoc(PinCode, EMITTER_EVENTS.attachPlayer),
	CreateLanguage: modalWindowHoc(CreateLanguage, EMITTER_EVENTS.createLanguage),
	HallStatistics: modalWindowHoc(HallStatistics, EMITTER_EVENTS.hallStatistics),
	AddingPaymentSystem: modalWindowHoc(
		AddingPaymentSystem,
		EMITTER_EVENTS.addingPaymentSystem
	),
	AddingCurrencyInCatalog: modalWindowHoc(
		AddingCurrencyInCatalog,
		EMITTER_EVENTS.addingCurrencyInCatalog
	),
	AddingWidget: modalWindowHoc(AddingWidget, EMITTER_EVENTS.addingWidget),
	CreatePromoCodes: modalWindowHoc(
		CreatePromoCodes,
		EMITTER_EVENTS.createPromoCodeForHalls
	),
	CreateReport: modalWindowHoc(CreateReport, EMITTER_EVENTS.createReport),
}
</script>
